export default __webpack_public_path__ + "static/student-left-e9dafeb4cbb8ddfe831fbfc04eb5e8f1.jpg";